import { JWTRole } from "@hackthenorth/north";

import { HackerStage } from "src/shared/contexts/HackerContext/types";

// Current non-sponsor attendee types from the 2026 attendee export. North's
// JWTRole enum does not yet include general or visitor.
export const ATTENDEE_ROLES: readonly string[] = [
  JWTRole.HACKER,
  JWTRole.ORGANIZER,
  JWTRole.VOLUNTEER,
  JWTRole.MENTOR,
  JWTRole.WORKSHOP_LEAD,
  JWTRole.JUDGE,
  "general",
  "visitor",
];

// Use the same policy for the shell, RSVP data provider, and RSVP navigation.
// Company-specific sponsor roles continue to require the existing sponsor role.
export const hasRsvpAccess = (
  roles: readonly string[],
  isOrganizer: boolean
): boolean =>
  isOrganizer ||
  roles.some(
    (role) => role === JWTRole.SPONSOR || ATTENDEE_ROLES.includes(role)
  );

export const canEditRsvp = (stage?: HackerStage): boolean =>
  stage === HackerStage.ACCEPTED ||
  stage === HackerStage.AUTO_ACCEPTED ||
  stage === HackerStage.CONFIRMED;
